<template>
  <div class="question-page">
    <h1 class="heading" v-html="activeQuestion"></h1>

    <div class="buttons">
      <ul v-show="activeTab==1" class="options">
        <li
          v-for="(option,index) in feedbackOptions"
          :key="index"
          :class="{inactive:feedback[0] && feedback[0]!==index+1, active:feedback[0]===index+1,disabled:!user.isController}"
          @click="$store.dispatch('setFeedback',{q:0,a:index+1})"
        >
          [
          <span class="icon">/</span> ]
          <i>{{option}}</i>
        </li>
      </ul>

      <ul v-show="activeTab==2" class="options">
        <li
          v-for="(option,index) in feedbackOptions"
          :key="index"
          :class="{inactive:feedback[1] && feedback[1]!==index+1, active:feedback[1]===index+1,disabled:!user.isController}"
          @click="$store.dispatch('setFeedback',{q:1,a:index+1})"
        >
          [
          <span class="icon">/</span> ]
          <i>{{option}}</i>
        </li>
      </ul>

      <ul v-show="activeTab==3" class="options">
        <li
          v-for="(option,index) in feedbackOptions"
          :key="index"
          :class="{inactive:feedback[2] && feedback[2]!==index+1, active:feedback[2]===index+1,disabled:!user.isController}"
          @click="$store.dispatch('setFeedback',{q:2,a:index+1})"
        >
          [
          <span class="icon">/</span> ]
          <i>{{option}}</i>
        </li>
      </ul>

      <ul v-show="activeTab==4" class="options">
        <li
          v-for="(option,index) in feedbackOptions"
          :key="index"
          :class="{inactive:feedback[3] && feedback[3]!==index+1, active:feedback[3]===index+1,disabled:!user.isController}"
          @click="$store.dispatch('setFeedback',{q:3,a:index+1})"
        >
          [
          <span class="icon">/</span> ]
          <i>{{option}}</i>
        </li>
      </ul>

      <ul v-show="activeTab==5" class="options">
        <li
          v-for="(option,index) in feedbackOptions"
          :key="index"
          :class="{inactive:feedback[4] && feedback[4]!==index+1, active:feedback[4]===index+1,disabled:!user.isController}"
          @click="$store.dispatch('setFeedback',{q:4,a:index+1})"
        >
          [
          <span class="icon">/</span> ]
          <i>{{option}}</i>
        </li>
      </ul>
    </div>

    <div class="page-subnav">
      <a
        :class="{active:activeTab===1,disabled:!user.isController}"
        @click="$store.dispatch('setFeedbackTab',1)"
      >q1</a>
      <span class="rarrow">></span>
      <a
        :class="{active:activeTab===2,disabled:!user.isController}"
        @click="$store.dispatch('setFeedbackTab',2)"
      >q2</a>
      <span class="rarrow">></span>
      <a
        :class="{active:activeTab===3,disabled:!user.isController}"
        @click="$store.dispatch('setFeedbackTab',3)"
      >q3</a>
      <span class="rarrow">></span>
      <a
        :class="{active:activeTab===4,disabled:!user.isController}"
        @click="$store.dispatch('setFeedbackTab',4)"
      >q4</a>
      <span class="rarrow">></span>
      <a
        :class="{active:activeTab===5,disabled:!user.isController}"
        @click="$store.dispatch('setFeedbackTab',5)"
      >q5</a>
    </div>
  </div>
</template>

<script>
import feedbackJson from "@/data/feedback.json";
import { mapState } from "vuex";

export default {
  name: "questionnaire-page",

  computed: {
    ...mapState(["user", "feedback", "feedbackActiveTab"]),
    feedbackOptions() {
      return feedbackJson.feedbackOptions;
    },
    activeQuestion() {
      return feedbackJson.feedbackQuestions[this.activeTab - 1];
    },
    activeTab: {
      set(value) {
        this.$store.commit("SET_FEEDBACK_TAB", value);
      },
      get() {
        return this.feedbackActiveTab;
      }
    }
  }
};
</script>

<style lang="less">
.question-page {
  position: relative;
  width: 768px;
  height: 768px;
  padding: 120px;
  background-image: url("~@/assets/images/page-blank.png");

  .heading {
    margin-bottom: 15px;
  }

  .options {
    padding: 0;
    margin: 0;

    li {
      list-style: none;
      cursor: pointer;

      .icon {
        display: inline-block;
        width: 10px;
        text-align: center;
        opacity: 0;
      }

      &.inactive {
        opacity: 0.25;
      }

      &.active {
        .icon {
          opacity: 1;
        }
      }

      &.disabled {
        cursor: not-allowed;
      }
    }
  }

  .page-subnav {
    position: absolute;
    bottom: 30px;
    right: 90px;
    font-size: 13px;

    a {
      font-style: italic;
      opacity: 0.25;
      cursor: pointer;

      &:hover,
      &.active {
        opacity: 1;
      }
      &.disabled {
        cursor: not-allowed;
      }
    }

    .rarrow {
      opacity: 0.25;
      margin: 0 5px;
    }
  }
}
</style>
